import {OFFER_LIST_SCROLL_TARGET} from '@/modules/offers/consts';

export const scrollToOfferlistIfPossible = (behavior?: ScrollBehavior) => {
  const element = document.getElementById(OFFER_LIST_SCROLL_TARGET);

  if (element === null) {
    return;
  }

  // position to be taken into account due to the seachrBar component
  const searchBarOffset = -130;
  const offsetPosition =
    element.getBoundingClientRect().top + window.scrollY + searchBarOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior,
  });
};
